export default __webpack_public_path__ + "static/images/2375cffc3536e741d76c2f7004e768e0.png";